var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',[_c('img',{attrs:{"src":require("@/assets/edit_calendar.svg"),"alt":""}}),_c('router-link',{attrs:{"to":"/"}},[_c('h1',[_vm._v("My "),_c('span',[_vm._v("Notes")])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }